import { randomInt } from '../Random';
import { PinPath, Point } from '../Types';

function randomNonZeroDelta(maxAbsDelta: number): number {
    const abs = randomInt(maxAbsDelta) + 1;
    return Math.random() < 0.5 ? -abs : abs;
}

export function generatePath(points: Point[], length: number, maxExitDelta: number = 5): PinPath {
    const pinIndices = new Array<number>(length);
    for (let i = 0; i < length; ++i) {
        pinIndices[i] = randomInt(points.length);
    }

    const exitDeltas = new Array<number>(Math.max(0, length - 1));
    for (let i = 0; i < exitDeltas.length; i++) {
        exitDeltas[i] = randomNonZeroDelta(maxExitDelta);
    }

    return { pinIndices, exitDeltas };
}
